import { useMemo } from 'react';
import { detectOs } from '@/utils/detectOs';
import { isEmbed } from '@/config/embed';
import { EXTERNAL_URLS } from '@/constants/urls';
import type { StoreKind } from '@/components/landing/StoreBadge';

/**
 * The store this device can install VoteMate from, or null when there's nothing
 * to install (desktop, or a partner embed). Mirrors the guest-landing badge's
 * platform gate so the store badge shows in the same places app-wide.
 */
export function useAppStoreLink(): { os: StoreKind; href: string } | null {
  return useMemo(() => {
    if (isEmbed()) return null;
    const os = detectOs();
    if (os === 'ios') return { os, href: EXTERNAL_URLS.APP_STORE };
    if (os === 'android') return { os, href: EXTERNAL_URLS.PLAY_STORE };
    return null;
  }, []);
}
